import { STORY_SOURCE, story } from '@/content/storyBuilder'

// The six without a `doc` — Assan, Borusan, Bridgestone, Federal Mogul,
// Netafim and Lila Kağıt — were not among the sixteen PDFs sent on
// 2026-08-27, so their pages carry no button. Order is the live site's and is
// not re-sorted to group them; see the note above.
// The tenth written page. Everything below comes from the three-part full-page
// capture of digitopia.co/customers/assan-aluminium/ sent on 2026-08-28 —
// "tastamam şekilde, aynısını, tıpkısını tasarla" — with the two photographs
// supplied alongside it: the coil warehouse the reference runs in the header,
// and the grinding sparks it runs full width under the standfirst.
//
// Its shape is the reference's and not the template's usual: no grey panels
// anywhere and nothing centred below the standfirst, because the reference
// runs all four parts of the story as left-ranged prose on the white page.
// No lists either — every part is one or two paragraphs.
//
// The one thing the same request asked for that this page cannot draw is the
// testimonial card at the foot: `content/testimonials.ts` holds nineteen
// quotes and none of them is Assan's. See the check.
export const added = story('assan-aluminium', 'Assan Aluminium', {
  lede: ['Thinking about the past, the present, and our digital future…'],
  heroPhoto: {
    src: '/photo/assan-aluminium-coil-warehouse.webp',
    alt: 'Rows of aluminium coils on teal cradles down both sides of a lit mill aisle, '
      + 'green and red floor lanes running to the far end of the hall.',
  },
  intro:
    'Assan Aluminium, one of the world’s leading manufacturer in the flat-rolled aluminium '
    + '(FRP) industry, has been producing coil & sheet, foil and pre-painted aluminium '
    + 'products since its establishment in 1988, offering its products to a variety of '
    + 'sectors such as packaging, distribution, construction, consumer durables, automotive '
    + 'and HVAC.',
  photo: {
    src: '/photo/assan-aluminium-grinding-sparks.webp',
    alt: 'An angle grinder throwing a spray of orange sparks along a steel profile on a '
      + 'workshop bench.',
  },
  sections: [
    {
      heading: 'The Need?',
      body: [
        'Assan Aluminium is one of the biggest aluminium manufacturers in Europe. They are '
        + 'continuously growing. Sustainability is a top priority. Environment, health, and '
        + 'safety is similarly important. They are running multiple projects at the same '
        + 'time, from lean processes to agile culture, and system upgrades. But they did not '
        + 'have a precise measurement to determine where they were on their digital journey.',
      ],
    },
    {
      heading: 'The Solution',
      body: [
        'Digitopia offered their Digital Maturity Index solution to Assan Aluminium. '
        + 'Management recognised the value of assessing and benchmarking their digital '
        + 'maturity. Moreover, they also realised that they would set the baseline for '
        + 'further assessments. After all, the most important benchmark is the one against '
        + 'your own past performance, showing your progress.',
      ],
    },
    {
      heading: 'The Benefits',
      body: [
        'The sessions with Digitopia were attended by the whole executive leadership team. '
        + 'This enabled visibility and emphasis on the highest level. Assan Aluminium team '
        + 'established a mutual understanding of digital transformation, their vision, and '
        + 'established shared goals.',
        'The results were highly appreciated. Now, the executive leadership team knows '
        + 'exactly where they are, where they need to go, and what they must do about it. '
        + 'This is exactly the essence of the digital maturity assessment, and this is '
        + 'exactly what Digitopia is passionate about.',
      ],
    },
    {
      heading: 'The Next Steps',
      body: [
        'Now, it’s all about execution and assuring everything is on track. The management '
        + 'team runs a holistic improvement program, covering many digital initiatives, and '
        + 'they are keen to re-assessing their digital maturity again and again. This will '
        + 'show them their progress, their velocity, and their endurance. Since digital '
        + 'transformation is rather a longer journey.',
      ],
    },
  ],
  check:
    'This page’s words were transcribed from a three-part full-page capture of '
    + `${STORY_SOURCE}/assan-aluminium/ supplied on 2026-08-28, not from a file we hold, so `
    + 'please proofread it against the source before production. Two grammatical oddities are '
    + 'the reference’s own and were left verbatim rather than silently corrected in a '
    + 'customer’s own description of itself: “one of the world’s leading manufacturer” and '
    + '“they are keen to re-assessing”. Note also that the page’s lede — “Thinking about the '
    + 'past, the present, and our digital future…” — is the reference’s, and digitopia.co '
    + 'uses the same line on the LC Waikiki story; it is not a transcription slip, but it may '
    + 'be worth giving Assan its own. **The testimonial card asked for at the foot of this '
    + 'page is not drawn, and cannot be until somebody supplies the quote.** Assan Alüminyum’s '
    + 'mark is in hand (it is the plate in the page header on the Customers grid) and the '
    + 'template puts a portrait beside it, but content/testimonials.ts holds nineteen quotes '
    + 'and none of them is Assan’s — the reference page has no quote on it either, so there '
    + 'was nothing to copy. Send the words, the speaker’s name and title, and the card appears '
    + 'in one entry there; writing a plausible-sounding quote for a named customer was the one '
    + 'thing not on the table. Two deliberate differences from the reference, each of them a '
    + 'template-wide decision rather than this page’s: the header eyebrow reads “Digitopia / '
    + 'Customer Success Story” where digitopia.co reads “SUCCESS STORIES”, and this story has '
    + 'no PDF, so there is no “Read the full story” button — it was not among the sixteen '
    + 'documents sent on 2026-08-27. One production note: both photographs are small '
    + 'originals — 768×432 and 1200×455, which is what the live site serves — so they are '
    + 'drawn at that width and will look soft on a high-density screen until larger files '
    + 'arrive.',
})

/** Its place in the hand-placed order the imported Customers page set. */
export const order = 15
